import React from "react";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useHover } from "react-use";

export default function SortIcon(props: any) {
	const element = (hovered: boolean) => (
		<div className="flex flex-col ml-1 h-7 w-6" {...props}>
			{(props.direction || hovered) && (
				<>
					<ArrowDropUpIcon
						style={{
							fill: props.direction === "desc" ? "#e09145" : "#ebebeb",
						}}
						fontSize="small"
						className="-mb-2"
					/>
					<ArrowDropDownIcon
						style={{
							fill: props.direction === "asc" ? "#e09145" : "#ebebeb",
						}}
						fontSize="small"
						className="-mt-1"
					/>
				</>
			)}
		</div>
	);
	const [hoverable] = useHover(element);

	return <div>{hoverable}</div>;
}
